import { Observable } from 'rxjs';
import { ToolbarPosition } from 'shared/classroom/toolbar/core';

/**
 * The toolbar's place after a drag: distance of its bottom-right corner from the frame's right / bottom edge.
 * `frame` = the drag boundary's rect (the fixed containing block), NOT window.innerWidth/innerHeight:
 * those include a classic scrollbar (Windows) and change with the mobile address bar / pinch-zoom.
 */
export const toSavedPosition = (
    rect: Pick<DOMRect, 'right' | 'bottom'>,
    frame: Pick<DOMRect, 'right' | 'bottom'>,
): ToolbarPosition => ({
    right: Math.round(frame.right - rect.right),
    bottom: Math.round(frame.bottom - rect.bottom),
});

/** Emits whenever the element's size changes (and once when observing starts). */
export function observeResize(element: HTMLElement): Observable<void> {
    return new Observable<void>(subscriber => {
        const observer = new ResizeObserver(() => subscriber.next());
        observer.observe(element);
        return () => observer.disconnect();
    });
}
